module.exports = __webpack_public_path__ + "static/fivecarat-soul-87aab2e1b506e681d4f15ebf65ad8aa1.jpg";